<template>
  <SwwField
    v-model="context.value.value[props.field.key]"
    :field="props.field"
  />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import SwwField from '@/apps/brelag/mandator-user/components/editor/sww/SwwField.vue'

import type { SchemaFormKitProps } from './types'

const context = useFormKitContext()
const props = defineProps<SchemaFormKitProps>()
</script>

<style></style>
